export default (state = {}) => {
  return {
    ...state,
    allClients: {},
    allTeams: {},
    allPerformances: {},
    allEarnings: {},
    homeMetrics: {},
    metricMeta: {},
  };
};
